/** Qawaem AI Agent — configuration */

export const AI_CLOUD_API_BASE =
  process.env.REACT_APP_AI_API_URL ||
  'https://qawaem-platform.qawaemaicode.workers.dev';

export const AI_CHAT_ENDPOINT = `${AI_CLOUD_API_BASE}/ai/chat`;
export const AI_EXTRACT_DOCUMENT_ENDPOINT = `${AI_CLOUD_API_BASE}/ai/extract-document`;
export const AI_TRANSCRIBE_ENDPOINT = `${AI_CLOUD_API_BASE}/ai/transcribe`;
export const AI_VECTORIZE_SYNC_ENDPOINT = `${AI_CLOUD_API_BASE}/ai/vectorize/sync`;
export const AI_VECTORIZE_STATUS_ENDPOINT = `${AI_CLOUD_API_BASE}/ai/vectorize/status`;

/** Cloudflare Workers AI — voice transcription */
export const AI_WHISPER_MODEL = '@cf/openai/whisper-large-v3-turbo';

/** Max messages kept in session memory */
export const AGENT_HISTORY_LIMIT = 20;

/** Messages sent as context to cloud AI */
export const AGENT_CONTEXT_HISTORY_LIMIT = 5;

/** Max entities per type sent in context payload */
export const AGENT_CONTEXT_ENTITY_LIMIT = 50;

/** Records per Vectorize sync batch (worker max 250) */
export const AGENT_VECTORIZE_SYNC_BATCH = 200;

/** Agent engine: hermes | cloud | hybrid (see hermesConfig.getAgentEngineMode) */
export const AGENT_ENGINE = process.env.REACT_APP_AGENT_ENGINE || 'hybrid';

export const HERMES_API_BASE =
  process.env.REACT_APP_HERMES_API_BASE || 'http://127.0.0.1:8642';

export const HERMES_CAPABILITIES_ENDPOINT = `${HERMES_API_BASE}/v1/capabilities`;
export const HERMES_CHAT_ENDPOINT = `${HERMES_API_BASE}/v1/chat/completions`;
